<template>
  <div class="lg:mt-10 md:mt-9 mt-5 lg:flex md:flex gap-2">
    <div class="container">
      <div class="w-full lg:flex md:flex gap-4">
        <div class="lg:w-3/12 md:w-4/12 w-full">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/palliative-care/What%20ia%20Pallative%20Care.jpg"
            alt="what is palliative care"
            class="firstab_img object-cover"
          />
        </div>
        <div class="lg:w-9/12 md:w-8/12 w-full lg:mt-0 md:mt-0 mt-4">
          <h2 class="fsize32 sm-fsize24 font-bold text4F0A4B">
            What is Palliative Care?
          </h2>
          <p class="fsize16 sm-fsize14">
            Palliative care is a specialized form of healthcare that focuses on
            providing relief from the symptoms and stress of serious illnesses.
            The goal of palliative care is to improve the quality of life for
            both the patient and their family by addressing physical, emotional,
            and spiritual needs.  <br />
            Palliative care is not just for patients who are terminally ill, but
            for those who are dealing with serious illnesses that affect their
            daily lives. The goal of palliative care is to provide comfort and
            support to patients and their families throughout the course of the
            illness. 
          </p>
        </div>
      </div>
      <div class="mt-10">
        <h2 class="fsize22 font-medium text-primary">
          There are several reasons
        </h2>
        <h2 class="fsize24 font-bold text-primary">
          Why palliative care is important ? 
        </h2>
      </div>
      <div class="grid grid-cols-1 gap-8 mt-6">
        <div class="w-full lg:flex md:flex items-center gap-4">
          <div class="lg:w-4/12 md:w-3/12 w-full">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/palliative-care/Improved%20Quality%20of%20Life.jpg"
              alt="improved quality of life"
              class="firstab_image_var1 object-cover"
            />
          </div>
          <div class="lg:w-8/12 md:w-9/12 w-full lg:mt-0 md:mt-0 mt-4">
            <h2 class="fsize20 font-bold text4F0A4B">
              Improved Quality of Life
            </h2>
            <p class="fsize14">
              Palliative care focuses on the quality of life, and it aims to
              reduce the symptoms of illness and improve the overall comfort of
              the patient.
            </p>
          </div>
        </div>
        <div class="w-full lg:flex md:flex items-center gap-4">
          <div class="lg:w-4/12 md:w-3/12 w-full">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/palliative-care/Family%20Support.jpg"
              alt="family support"
              class="firstab_image_var2 object-cover"
            />
          </div>
          <div class="lg:w-8/12 md:w-9/12 w-full lg:mt-0 md:mt-0 mt-4">
            <h2 class="fsize20 font-bold text4F0A4B">Family Support</h2>
            <p class="fsize14">
              Palliative care provides support not only to the patient, but also
              to their families. This support includes counseling, education,
              and emotional support.
            </p>
          </div>
        </div>
        <div class="w-full lg:flex md:flex items-center gap-4">
          <div class="lg:w-4/12 md:w-3/12 w-full">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/palliative-care/Pain%20Management.jpg"
              alt="pain management"
              class="firstab_image_var1 object-cover"
            />
          </div>
          <div class="lg:w-8/12 md:w-9/12 w-full lg:mt-0 md:mt-0 mt-4">
            <h2 class="fsize20 font-bold text4F0A4B">Pain Management</h2>
            <p class="fsize14">
              One of the primary goals of palliative care is to manage pain and
              other physical symptoms, such as fatigue, nausea, and shortness of
              breath.
            </p>
          </div>
        </div>
        <div class="w-full lg:flex md:flex items-center gap-4">
          <div class="lg:w-4/12 md:w-3/12 w-full">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/palliative-care/Spiritual%20and%20Emotional%20Support.jpg"
              alt="spiritual and emotional support"
              class="firstab_image_var2 object-cover"
            />
          </div>
          <div class="lg:w-8/12 md:w-9/12 w-full lg:mt-0 md:mt-0 mt-4">
            <h2 class="fsize20 font-bold text4F0A4B">
              Spiritual and Emotional Support
            </h2>
            <p class="fsize14">
              Palliative care addresses the emotional and spiritual needs of
              patients and their families. It provides support for patients who
              are dealing with anxiety, depression, or other emotional issues.
            </p>
          </div>
        </div>
        <div class="w-full lg:flex md:flex items-center gap-4">
          <div class="lg:w-4/12 md:w-3/12 w-full">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/palliative-care/better%20pain%20management.jpg"
              alt="increased life expectancy"
              class="firstab_image_var1 object-cover"
            />
          </div>
          <div class="lg:w-8/12 md:w-9/12 w-full lg:mt-0 md:mt-0 mt-4">
            <h2 class="fsize20 font-bold text4F0A4B">
              Increased Life Expectancy
            </h2>
            <p class="fsize14">
              Palliative care has been shown to increase the life expectancy of
              patients. This is because patients who receive palliative care
              often have better pain management, which can improve their overall
              health.
            </p>
          </div>
        </div>
      </div>
      <p class="fsize16 text-dark mt-8">
        In conclusion, palliative care is an important aspect of healthcare that
        provides relief and support to patients and their families who are
        dealing with serious illnesses. It focuses on the quality of life and
        provides support for both physical and emotional needs. If you or a
        loved one is dealing with a serious illness, consider talking to your
        healthcare provider about palliative care options. 
      </p>
    </div>
    <!-- <div class="border-left lg:w-2/12 md:w-2/12 w-full lg:mt-0 md:mt-0 mt-4">
      <SideBlogs />
    </div> -->
  </div>
</template>
<script>
import SideBlogs from "./components/SideBlogs.vue";
export default {
  components: {
    SideBlogs,
  },
};
</script>
<style>
.firstab_img {
  height: 210px;
  width: 100%;
  border-radius: 80px 0 0 0;
}
.firstab_image_var1 {
  height: 140px;
  width: 100%;
  border-radius: 50px 0 0 0;
}
.firstab_image_var2 {
  height: 140px;
  width: 100%;
  border-radius: 0px 0 50px 0;
}
</style>
